import { render, staticRenderFns } from "./VisitPracticeList.vue?vue&type=template&id=38e3f08a&"
import script from "./VisitPracticeList.vue?vue&type=script&lang=js&"
export * from "./VisitPracticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports